import React, { ReactElement } from 'react';
import {
  trackContactEnquiryForm,
  trackContactRecommendations,
} from '../../tracking';
import {
  ContactEnquiryFormWithFragment,
  InView,
  RecommendationsEnquirySection,
} from '../../components';
import { ContactRecommendationsWithStarRatingsAndQuery } from '../../components/contact-recommendations-with-star-ratings';
import RecommendationTitle from '../../components/shared/recommendation-title';
import { ReviewsProvider } from '../../components/recommendations-enquiry-section';
import { PROFILE_TIERS } from '../../constants';
import { OverallStarRating } from '../../components/shared/recommendations/types';

type ContactAreaProps = {
  agentIdV2: string;
  agencyId: number;
  contactId: number;
  overallStarRating?: OverallStarRating;
  imageFormat?: string;
};

interface AgentRecommendationsWithStarRatingProps extends ContactAreaProps {
  profileTier?: PROFILE_TIERS;
  title?: string;
  overallStarRating?: OverallStarRating;
}

const ContactArea: React.FC<ContactAreaProps> = ({
  agentIdV2,
  agencyId,
  contactId,
  overallStarRating,
  imageFormat,
}: ContactAreaProps): ReactElement => (
  <InView onActivate={trackContactEnquiryForm.trackEnquiryFormViewed}>
    <ContactEnquiryFormWithFragment
      agentIdV2={agentIdV2}
      agencyId={agencyId}
      contactId={contactId}
      overallStarRating={overallStarRating}
      onSelectIntent={trackContactEnquiryForm.trackSelectIntent}
      onSubmitIntent={trackContactEnquiryForm.trackSubmitIntent}
      onSubmit={trackContactEnquiryForm.trackSubmit}
      onSubmitSuccess={trackContactEnquiryForm.trackSubmitSuccess}
      onSubmitError={trackContactEnquiryForm.trackSubmitError}
      imageFormat={imageFormat}
    />
  </InView>
);

export const AgentRecommendationsWithStarRating: React.FC<
  AgentRecommendationsWithStarRatingProps
> = ({
  agentIdV2,
  agencyId,
  contactId,
  title,
  profileTier,
  overallStarRating,
  imageFormat,
}: AgentRecommendationsWithStarRatingProps): ReactElement => (
  <ReviewsProvider>
    <RecommendationTitle
      title={title || ''}
      overallStarRating={overallStarRating}
    />
    <RecommendationsEnquirySection
      recommendations={
        <ContactRecommendationsWithStarRatingsAndQuery
          starRatingsEnabled
          agentIdV2={agentIdV2}
          agencyId={agencyId}
          onPageRendered={trackContactRecommendations.trackContactPageRendered}
          onVendorRecoViewAll={trackContactRecommendations.trackContactViewAll}
          onVendorRecoRendered={
            trackContactRecommendations.trackContactRendered
          }
          onVendorRecoImpression={
            trackContactRecommendations.trackContactImpression
          }
          onVendorRecoModalViewMore={
            trackContactRecommendations.trackContactModalViewMore
          }
          onVendorRecoModalPrev={
            trackContactRecommendations.trackContactModalPrevious
          }
          onVendorRecoModalNext={
            trackContactRecommendations.trackContactModalNext
          }
        />
      }
      enquiryForm={
        <ContactArea
          agentIdV2={agentIdV2}
          agencyId={agencyId}
          contactId={contactId}
          overallStarRating={overallStarRating}
          imageFormat={imageFormat}
        />
      }
      profileTier={profileTier}
    />
  </ReviewsProvider>
);

export default AgentRecommendationsWithStarRating;
